import api from '../api'
import { PathCreateData, PathData } from '../../types/paths/paths'

export const fetchPathList = async ({
  page,
  pageSize,
  search,
  filters,
}: {
  page: number
  pageSize: number
  search: string
  filters?: {
    is_template?: boolean
    published?: boolean
    ordering?: string
  }
}) => {
  const params: Record<string, any> = {
    page,
    search,
    page_size: pageSize,
  }

  if (filters) {
    Object.entries(filters).forEach(([key, values]) => {
      if (Array.isArray(values)) {
        if (values.length > 1) {
          params[`${key}__in`] = values.join(',')
        } else if (values.length === 1) {
          params[key] = values[0]
        }
      } else {
        params[key] = values
      }
    })
  }

  const res = await api.get('/path/', { params })
  return res.data
}

export const createPath = async (pathData: PathCreateData) => {
  const res = await api.post('/path/', pathData)
  return res.data
}

export const fetchPath = async (id: string) => {
  const res = await api.get(`/path/${id}/`)
  return res.data
}

export const updatePath = async (id: string, pathData: PathCreateData) => {
  const res = await api.put(`/path/${id}/`, pathData)
  return res.data
}

export const patchPath = async (id: string, partialData: Partial<PathData>) => {
  const res = await api.patch(`/path/${id}/`, partialData)
  return res.data
}

export const deletePath = async (id: string) => {
  const res = await api.delete(`/path/${id}/`)
  return res.data
}

export const publishPath = async (id: string, pathData: PathCreateData) => {
  const res = await api.post(`/path/${id}/publish/`, pathData)
  return res.data
}

export const unpublishPath = async (id: string, pathData: PathCreateData) => {
  const res = await api.post(`/path/${id}/unpublish/`, pathData)
  return res.data
}

export const fetchParticipationHistory = async (participationId: string, nodeId: string) => {
  const res = await api.get(`/path/participations/${participationId}/history/`, { params: { node: nodeId } })
  return res.data
}

export const fetchParticipationByEmployeeAndPath = async (employeeId: string, pathId: string) => {
  const res = await api.get('/path/participations/', {
    params: { employee: employeeId, path: pathId },
  })
  return res.data
}
